/* tslint:disable */

// AUTO-GENERATED FILE. DO NOT EDIT.

export const CURRENT_REVISION = "4c6ac6f4db09cdc224bc373025fdb567e1b507c5";
